import React, { Component } from 'react';
import Codemirror from 'react-codemirror';
import 'codemirror/mode/pug/pug';
import 'codemirror/mode/xml/xml';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/monokai.css';
import back from './back.png';
import ls from 'local-storage';
import lex from 'pug-lexer';
import parse from 'pug-parser';
import wrap from 'pug-runtime/wrap';
import generateCode from 'pug-code-gen';
import htmlparser2 from 'htmlparser2';
import mousePosition from 'mouse-position';


import 'flag-icon-css/css/flag-icon.css';

const DEFAULT_SVG = `
svg(width="100%" height="100%" viewbox="0 0 240 180" fill="transparent")
  path(d="M0 0h76v180h-76Z" fill="#0018a8")
  path(d="M76 0h88v180h-88Z" fill="#fedf00")
  path(d="M164 0h76v180h-76Z" fill="#d0103a")
  path(d="M120 129c-6-1-12-3-9-6c-2-9-32 5-23-24c5-3 6-6 1-9c-9-9-5-16 6-19c-15-14 10-17 10-10c0 2 3 2 6 1c-3-10 0-12 9-7c10-5 13-3 9 7c3 1 6 1 6-1c0-8 25-4 10 10c11 3 14 10 6 19c-4 4-4 7 1 9c9 29-21 16-23 24c3 3-9 6-9 6Z" fill="#B59967")
  path(d="M99 66h42v37c-4 9-16 1-21 6c-4-5-18 3-21-7v-37Z" fill="#fedf00")
  path(d="M99 66h20v20h-20v-20ZM125 98c3 1 7 1 11 1l-1 7c-2-3-7-3-9 0c1-5-5-5-2-7ZM125 89c3 1 7 1 11 1l-1 7c-2-3-7-3-9 0c1-5-5-5-2-7Z" fill="#d52b1e")
  path(d="M120 64v46M98 87h44" stroke-width=2 stroke="#c7b37f")
  path(d="M125 66v20M131 66v20M137 66v20" stroke-width=3 stroke="#d52b1e")
  path(d="M103 88v19M107 88v20M111 88v20M115 88v20" stroke-width=2 stroke="#d52b1e")
  path(d="M109 68l5 7l-3 7h-5l-3-6l5-7Z" fill="#fedf00" stroke="#fff")
  path(d="M100 83c0-11 5 9 9-3c3 13 9-8 8 3" stroke="#fff")
`.trim();

const countries = [
  'ad', 'ae', 'af', 'ag', 'ai', 'al', 'am', 'ao', 'aq', 'ar',
  'as', 'at', 'au', 'aw', 'ax', 'az', 'ba', 'bb', 'bd', 'be',
  'bf', 'bg', 'bh', 'bi', 'bj', 'bl', 'bm', 'bn', 'bo', 'bq',
  'br', 'bs', 'bt', 'bv', 'bw', 'by', 'bz', 'ca', 'cc', 'cd',
  'cf', 'cg', 'ch', 'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'cr',
  'cu', 'cv', 'cw', 'cx', 'cy', 'cz', 'de', 'dj', 'dk', 'dm',
  'do', 'dz', 'ec', 'ee', 'eg', 'eh', 'er', 'es', 'et', 'fi',
  'fj', 'fk', 'fm', 'fo', 'fr', 'ga', 'gb', 'gd', 'ge', 'gf',
  'gg', 'gh', 'gi', 'gl', 'gm', 'gn', 'gp', 'gq', 'gr', 'gs',
  'gt', 'gu', 'gw', 'gy', 'hk', 'hm', 'hn', 'hr', 'ht', 'hu',
  'id', 'ie', 'il', 'im', 'in', 'io', 'iq', 'ir', 'is', 'it',
  'je', 'jm', 'jo', 'jp', 'ke', 'kg', 'kh', 'ki', 'km', 'kn',
  'kp', 'kr', 'kw', 'ky', 'kz', 'la', 'lb', 'lc', 'li', 'lk',
  'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me',
  'mf', 'mg', 'mh', 'mk', 'ml', 'mm', 'mn', 'mo', 'mp', 'mq',
  'mr', 'ms', 'mt', 'mu', 'mv', 'mw', 'mx', 'my', 'mz', 'na',
  'nc', 'ne', 'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nu',
  'nz', 'om', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm',
  'pn', 'pr', 'ps', 'pt', 'pw', 'py', 'qa', 're', 'ro', 'rs',
  'ru', 'rw', 'sa', 'sb', 'sc', 'sd', 'se', 'sg', 'sh', 'si',
  'sj', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'ss', 'st', 'sv',
  'sx', 'sy', 'sz', 'tc', 'td', 'tf', 'tg', 'th', 'tj', 'tk',
  'tl', 'tm', 'tn', 'to', 'tr', 'tt', 'tv', 'tw', 'tz', 'ua',
  'ug', 'um', 'us', 'uy', 'uz', 'va', 'vc', 've', 'vg', 'vi',
  'vn', 'vu', 'wf', 'ws', 'ye', 'yt', 'za', 'zm', 'zw'
];

const oneDigit = n => n.toString().length === 1;

const int = n => Math.round(parseFloat(n));
// const fl = n => parseFloat(n).toFixed(1).replace(/\.0$/, '');

const pathToAST = path => {
  const ast = [];
  let node = { data: '' }, c;
  for (let i = 0; i < path.length; i++) {
    c = path[i];
    if ('mMlLtTaAcCsSqQhHvVzZ'.indexOf(c) !== -1) {
      node = { cmd: c, data: '' };
      ast.push(node);
    } else if (c !== '"') {
      node.data += c;
    }
  }

  return ast.map(node => ({
    cmd: node.cmd,
    points: node.data
      .replace(/(\d)-/g, '$1 -')
      .split(/[^\d.-]+/)
      .filter(n => n.length)
      .map(n => parseFloat(n))
  }));
}

const astToPath = ast =>
  ast.map(node =>
    `${node.cmd}${node.points.join(' ').replace(/\s-/g, '-')}`
  ).join('');

const absToRel = path => {
  const ast = pathToAST(path);
  
  let p = { x: 0, y: 0 };
  let x, y, x1, y1, x2, y2;

  const relAst = ast
    .map(node => {
      switch(node.cmd) {
      case 'M':
        [x, y] = node.points;
        p = { x, y };
        break;
      case 'm':
        [x, y] = node.points;
        p = { x: p.x + x, y: p.y + y };
        break;
      case 'L':
        [x, y] = node.points;
        if (!oneDigit(x) || !oneDigit(y)) {
          node = { cmd: 'l', points: [x - p.x, y - p.y] };
        }
        p = { x, y };
        break;
      case 'H':
        [y] = node.points;
        if (!oneDigit(y)) {
          node = { cmd: 'h', points: [y - p.y] };
        }
        p = { x: p.x, y };
        break;
      case 'V':
        [x] = node.points;
        if (!oneDigit(x)) {
          node = { cmd: 'v', points: [x - p.x] };
        }
        p = { x, y: p.y };
        break;
      case 'C':
        [x1, y1, x2, y2, x, y] = node.points;
        node = { cmd: 'c', points: [x1 - p.x, y1 - p.y, x2 - p.x, y2 - p.y, x - p.x, y - p.y] };
        p = { x, y };
        break;
      case 'S':
        [x2, y2, x, y] = node.points;
        node = { cmd: 's', points: [x2 - p.x, y2 - p.y, x - p.x, y - p.y] };
        p = { x, y };
        break;
      default: break;
      }
      return node;
    }).map(node => {
      if (node.cmd === 'l') {
        const [x, y] = node.points;
        if (x === 0) return { cmd: 'v', points: [y] };
        if (y === 0) return { cmd: 'h', points: [x] };
      }
      return node;
    }).map(node =>({
      cmd: node.cmd,
      points: node.points.map(int)
    }))

  return astToPath(relAst);
}

const trimPath = path =>
  absToRel(path
    .replace(/(\d)[^\da-zA-Z]+([a-zA-Z])/g, '$1$2')
    .replace(/([a-zA-Z])[^\da-zA-Z-]+(\d)/g, '$1$2')
    .replace(/[,\s]+/g, ' ')
    .replace(/(\d)(-)/g, '$1 $2')
  );

const intOrPercent = n => n.indexOf('%') !== -1 ? `"${n}"` : int(n);

const defaultParseAttr = val => /^[.\d]+$/.test(val) ? val : `"${val}"`;
const parseAttr = (name, val) => (({
  d: v => `"${trimPath(val)}"`,
  width: intOrPercent,
  height: intOrPercent,
  x: int,
  y: int
})[name] || defaultParseAttr)(val.replace(/(^["']|["']$)/g, ''));

const replaceAttr = (name, val) => (({
  style: (n, v) => v.replace(/(^["']|["']$)/g, '').split(';')
    .map(pair => pair.split(':'))
    .map(([n, v]) => ({ name: n, val: `"${v}"`, type: 'attribute' }))
})[name] || ((n, v) => [{name: n, val: v, type: 'attribute' }]))(name, val);

const flatten = (arr, val) => (Array.isArray(val) ? [...arr, ...val] : [...arr, val]);

const processNode = node =>
  node.type === 'attribute' ? replaceAttr(node.name, node.val) : node;

const restAttrs = (attrs, omitAttrs) =>
  Object.keys(attrs)
    .filter(k => omitAttrs.indexOf(k) === -1)
    .map(k => ({
      type: 'attribute',
      name: k,
      val: attrs[k]
    }));

const replaceTags = () => {
  const mapTags = {
    rect: {
      name: 'path',
      defaultAttrs: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
      },
      mapAttrs: ({ x, y, width, height }) => [
        {
          type: 'attribute',
          name: 'd',
          val: `"M${x} ${y}h${width}v${height}H${x}Z"`
        }
      ]
    },
    // ellipse: {
    //   name: 'path',
    //   defaultAttrs: {
    //     cx: 0,
    //     cy: 0,
    //     rx: 0,
    //     ry: 0
    //   },
    //   mapAttrs: ({ cx, cy, rx, ry }) => [
    //     {
    //       type: 'attribute',
    //       name: 'd',
    //       val: `"M${cx} ${cy - ry}a${rx} ${ry} 0 0 1 0 ${2 * ry}a${rx} ${ry} 0 1 1 0 -${2 * ry}Z"`
    //     }
    //   ]
    // },
    // circle: {
    //   name: 'path',
    //   defaultAttrs: {
    //     cx: 0,
    //     cy: 0,
    //     r: 0
    //   },
    //   mapAttrs: ({ cx, cy, r }) => [
    //     {
    //       type: 'attribute',
    //       name: 'd',
    //       val: `"M${cx} ${cy - r}a${r} ${r} 0 0 1 0 ${2 * r}a${r} ${r} 0 1 1 0 -${2 * r}Z"`
    //     }
    //   ]
    // }
  };

  let lastTag;
  let attributes = {};

  return (ast, node) => {
    if (lastTag) {
      if (node.type === 'start-attributes') {
        attributes = {};
      } else if (node.type === 'end-attributes') {
        ast = [
          ...ast,
          ...lastTag.mapAttrs({ ...lastTag.defaultAttrs, ...attributes }),
          ...restAttrs(attributes, Object.keys(lastTag.defaultAttrs))
        ];
      } else if (node.type === 'attribute') {
        attributes[node.name] = node.val;
        return ast;
      }
    }

    if (node.type !== 'tag') {
      return [...ast, node];
    }

    lastTag = mapTags[node.val];

    return lastTag ? [...ast, { ...node, val: lastTag.name }] : [...ast, node];
  };
}

const xmlify = pug => {  
  try {
    const ast = lex(pug)
      .map(processNode)
      .reduce(flatten, [])
      .reduce(replaceTags(), [])
      .map(node => (node.type === 'attribute' ? {
        ...node,
        val: parseAttr(node.name, node.val)
      } : node))
      .map(node => (typeof node.val === 'number' ? {
        ...node,
        val: `"${node.val}"`
      } : node));
    const funcStr = generateCode(parse(ast), {
      compileDebug: false,
      pretty: true,
      inlineRuntimeFunctions: false,
      templateName: 'xmlify'
    });

    return {
      pug,
      svg: wrap(funcStr, 'xmlify')()
        .replace(/<([^\s]+)([^>]*)><\/(\1)>/g, '<$1$2 />')
        .trim(),
      error: undefined
    };
  } catch(e) {
    console.error(e);
    return {
      pug,
      error: e.message
    };
  }
}

const pugify = svg => {
  let ast = [];
  let offset = 0;

  const parser = new htmlparser2.Parser({
    onopentag: (name, attrs) => {
      ast.push({
        offset,
        name,
        attrs: Object.keys(attrs)
          .map(n => replaceAttr(n, attrs[n]))
          .reduce(flatten, [])
          .filter(({ name }) => name)
          .map(({ name, val }) => `${name}=${parseAttr(name, val)}`)
      });

      offset++;
    },
    onclosetag: (name) => {
      offset--;
    },
    oncomment: data => {
      ast.push({
        comment: data,
        offset
      })
    }
  });

  try {
    parser.parseComplete(svg);

    const pug = ast.reduce((str, node) => {
      str += '  '.repeat(node.offset);

      if (!node.name) {
        return `${str}//${node.comment.replace(/\n/g, ' ')}\n`;
      }

      str += node.name;

      if (node.attrs.length) {
        str += `(${node.attrs.join(' ')})`;
      }

      return str + '\n';
    }, '');

    return {
      svg,
      pug,
      error: undefined
    };
  } catch (e) {
    return {
      svg,
      error: e.message
    };
  }
}

class App extends Component {
  constructor(props) {
    super(props);
    const pug = ls('pug') || DEFAULT_SVG;
    this.state = {
      pug,
      svg: '',
      ...xmlify(pug),
      country: ls('selected_country') || 'ad'
    };
  }

  componentDidMount() {
    this.refs.pugEditor.codeMirror.setSize('100%', '100%');
    this.refs.svgEditor.codeMirror.setSize('100%', '100%');
  }

  render() {
    return (
      <div style={{ width: '100vw', height: '100vh' }}>
        <div style={{ display: 'flex', height: '100%' }}>
          <div
            style={{
              flex: '0 0 40%',
              background: '#272822',
              padding: '0 1rem',
              boxSizing: 'border-box',
              display: 'flex',
              flexDirection: 'column',
              maxWidth: '40vw',
              position: 'relative'
            }}
          >
            <div style={{
              boxSizing: 'border-box',
              flex: '0 1 50%',
              padding: '1rem 0',
              borderBottom: '2px solid #444444',
              overflowY: 'auto'
            }}>
              <Codemirror
                ref='pugEditor'
                value={this.state.pug}
                onChange={this.handlePugInput}
                options={{
                  mode: 'pug',
                  theme: 'monokai',
                  lineWrapping: true,
                  tabSize: 2,
                  extraKeys: {
                    Tab: function(cm) {
                      var spaces = Array(cm.getOption("indentUnit") + 1).join(" ");
                      cm.replaceSelection(spaces);
                    }
                  }
                }}
              />
            </div>
            <div style={{
              boxSizing: 'border-box',
              flex: '0 1 50%',
              padding: '1rem 0',
              overflowY: 'auto'
            }}>
              <Codemirror
                ref='svgEditor'
                value={this.state.svg}
                onChange={this.handleSvgInput}
                options={{
                  mode: 'xml',
                  theme: 'monokai',
                  lineWrapping: true,
                  tabSize: 2,
                  extraKeys: {
                    Tab: function(cm) {
                      var spaces = Array(cm.getOption("indentUnit") + 1).join(" ");
                      cm.replaceSelection(spaces);
                    }
                  }
                }}
              />
            </div>
            <div style={{
              position: 'absolute',
              bottom: '0.5rem',
              right: '0.5rem',
              color: '#FFFFFF'
            }}>{this.state.svg.length}</div>
          </div>
          <div
            style={{
              flex: '0 0 60%',
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundImage: `url('${back}')`,
              overflowY: 'auto'
            }}
          >
            {this.state.error && this.renderError(this.state.error)}
            {!this.state.error && this.renderFlags(15, 11.25, this.mountMousePosition)}
            {!this.state.error && this.renderFlags(6, 4.5)}
            {!this.state.error && this.renderFlags(2, 1.5)}
            {!this.state.error && this.renderFlags(1, 0.75)}
          </div>
        </div>
      </div>
    );
  }

  mountMousePosition = c => {
    this.flagRef = c;
    this.mouse = mousePosition(c);
  }

  renderError(error) {
    return (
      <div style={{ margin: '5rem' }}>
        {error}
      </div>
    );
  }

  renderFlags(w, h, flagRef) {
    const isFirstRow = !!flagRef;

    return (
      <div style={{ display: 'flex', flex: '0 0 auto' }}>
        <div style={{
          flex: '0 0 33%',
          padding: '1.5rem 0.5rem',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end'
        }}>
          {isFirstRow && <h5 style={{ alignSelf: 'center', flex: '0 0 auto' }}>Rendered</h5>}
          <div
            style={{
              flex: '0 0 auto',
              width: `${w}rem`,
              height: `${h}rem`,
              boxShadow: '0 0 0 1px #000000'
            }}
            dangerouslySetInnerHTML={{
              __html: this.state.svg.replace('<svg', '<svg style="display: block;"')
            }}
          />
        </div>
        <div style={{
          flex: '0 0 33%',
          padding: '1.5rem 0.5rem',
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          {isFirstRow && <h5 style={{ alignSelf: 'center', flex: '0 0 auto' }}>Original</h5>}
          <div
            ref={flagRef}
            onClick={flagRef && this.handleFlagClick}
            className={`flag-icon flag-icon-${this.state.country}`}
            style={{
              flex: '0 0 auto',
              width: `${w}rem`,
              height: `${h}rem`,
              boxShadow: '0 0 0 1px #000000',
              cursor: flagRef ? 'crosshair' : 'inherit'
            }}
          />
          {isFirstRow &&
            <div style={{
              flex: '0 0 auto',
              marginTop: '0.5rem',
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%'
            }}>
              <select
                onChange={this.handleCountryChange}
                style={{ fontSize: 18, borderColor: '#CCC' }}
                value={this.state.country}
              >
                {countries.map(c =>
                  <option key={c} value={c}>{c}</option>
                )}
              </select>
              {'\u{1F3AF}'}
              <input type='text' value={this.state.flagCoords} readOnly style={{ width: 70 }} />
              {'\u{1f3a8}'}
              <input type='text' value={this.state.pixelColor} readOnly style={{ width: 70 }} />
            </div>
          }
        </div>
        <div style={{
          flex: '0 0 33%',
          padding: '1.5rem 0.5rem',
          boxSizing: 'border-box'
        }}>
          {isFirstRow && <h5 style={{ alignSelf: 'center', flex: '0 0 auto' }}>Mixed</h5>}
          <div style={{ position: 'relative' }}>
            <div
              className={`flag-icon flag-icon-${this.state.country}`}
              style={{
                flex: '0 0 auto',
                width: `${w}rem`,
                height: `${h}rem`,
                boxShadow: '0 0 0 1px #000000',
                position: 'relative',
                top: -1,
                opacity: 0.5
              }}
            />
            <div
              style={{
                position: 'absolute',
                top:'0',
                width: `${w}rem`,
                height: `${h}rem`,
                boxShadow: '0 0 0 1px #000000',
                opacity: 0.5
              }}
              dangerouslySetInnerHTML={{
                __html: this.state.svg.replace('<svg', '<svg style="display: block;"')
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  handleFlagClick = () => {
    const x = Math.round(this.mouse[0]);
    const y = Math.round(this.mouse[1]);
    this.setState({ flagCoords: `${x} ${y}`});

    const flagImgUrl = getComputedStyle(this.flagRef)['background-image'].match(/url\("(.*)"\)/)[1];

    const img = new Image();
    img.src = flagImgUrl;
    img.onload = () => {
      console.log('loaded', img.src);
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d').drawImage(img, 0, 0, this.flagRef.offsetWidth, this.flagRef.offsetHeight);
      var pixelData = canvas.getContext('2d')
        .getImageData(x, y, 1, 1)
        .data;
      
      const pixelColor = '#' + ((1 << 24) + (pixelData[0] << 16) + (pixelData[1] << 8) + pixelData[2])
        .toString(16)
        .substr(1);

      this.setState({ pixelColor });
    };
  }

  handleCountryChange = e => {
    ls('selected_country', e.target.value);
    this.setState({ country: e.target.value });
  }

  handlePugInput = pug => {
    ls('pug', pug);
    this.setState(xmlify(pug));
  };

  handleSvgInput = svg => {
    const state = pugify(svg);
    if (state.pug) {
      ls('pug', state.pug);
    }
    this.setState(state);
  };
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/